import { Entity } from "@common/types/entity";
import { Payroll } from "@common/types/payroll";
import { payrollContract } from "@common/contracts/payroll.contract";
import { PayrollDto } from "@common/dto/gusto/payroll.dto";
import { getBackendAPIClient } from "./backendAPIClient";

const payrollApiClient = getBackendAPIClient(payrollContract);

export async function getEntityPayrolls(entity: Entity): Promise<Payroll[]> {
    const response = await payrollApiClient.getPayrolls({
        params: { entityId: entity.id },
    });

    return response.body.map((dto) => PayrollDto.deserialize(dto));
}
